import React, { useEffect, useState, useRef } from "react";
import { useAuth, db } from "../context/authContext";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { useRPM } from "../hooks/useRPM";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import Reloj from "./Reloj";
import Distancia from "./Distancia";
import Calorias from "./Calorias";
import logo from "../assets/Logo.png";



// 🔹 Emojis disponibles
const EMOJIS = ["❤️", "👍", "💪", "😅", "👊", "💦", "🐘", "🏆", "👏", "🥵"];

// 🔹 Nombres fake (solo 9 usuarios)
const NOMBRES_FAKE = [
  "Laura", "Carlos", "Ana",
  "David", "Sofía", "Pedro",
  "Marta", "Sergio", "Lucía"
];

export function HomeUser() {

  const { logout, EstadoLogout, addInfoGym, Estado } = useAuth();

  const [personas, setPersonas] = useState([]);
  const [miEmoji, setMiEmoji] = useState("");
  const navigate = useNavigate();

  // 👇 ahora sí traes el usuario del contexto
  const { user } = useAuth();

  // Estados de puntos (igual que en Home.js)
  const [puntosSesion, setPuntosSesion] = useState(0);   // progreso actual
  const [puntosLocal, setPuntosLocal] = useState(0);     // buffer en memoria
  const [puntosRanking, setPuntosRanking] = useState(0); // emojis lanzados
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success"); // "success" | "error"
  const gimnasio = JSON.parse(localStorage.getItem("gimnasio")) || "free";
  const claseId = JSON.parse(localStorage.getItem("claseId")) || "free";

  // 👇 estado local para tokens
  const [tokens, setTokens] = useState(0);
  const [nombreUsuario, setNombreUsuario] = useState("Yo");

  //Validar que estoy en homeuser

  // justo después de este bloque que ya tienes:
useEffect(() => {
  localStorage.setItem("lastPage", "homeuser");
}, []);

// 👇 guardar el contexto en Firestore y marcar activo al entrar
useEffect(() => {
  const activarUsuario = async () => {
    if (!user?.uid) return;

    try {
      const userRef = doc(db, "usuarios", user.uid);
      await updateDoc(userRef, {
        activo: true,
        ultimoContexto: "/homeuser",
      });
      console.log("🟢 Usuario activo en Firestore + contexto /homeuser");
    } catch (err) {
      console.error("❌ Error al activar usuario en HomeUser:", err);
    }
  };

  activarUsuario();
}, [user]);

// 👇 marcar inactivo al cerrar pestaña/ventana
useEffect(() => {
  const handleBeforeUnload = async () => {
    try {
      if (user?.uid) {
        const userRef = doc(db, "usuarios", user.uid);
        await updateDoc(userRef, { activo: false });
        console.log("🚪 Usuario marcado inactivo al cerrar HomeUser");
      }
    } catch (err) {
      console.error("❌ Error al marcar inactivo en HomeUser:", err);
    }
  };

  window.addEventListener("beforeunload", handleBeforeUnload);
  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, [user]);


  // suscripción a Firestore → tokens en vivo
  useEffect(() => {
    if (!user?.uid) return;
    const userRef = doc(db, "usuarios", user.uid);
    const unsubscribe = onSnapshot(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        setTokens(data.tokens || 0);
        localStorage.setItem("Tokens", data.tokens || 0);
        setNombreUsuario(data.nombre || user.displayName || "Yo");
      }
    });
    return () => unsubscribe();
  }, [user]);


  useEffect(() => {
    const syncHandler = (event) => {
      if (event.key === "cerrarClase") {
        console.log("🔄 Clase cerrada en otra pestaña");
        navigate("/comprobacion");
      }
    };
    window.addEventListener("storage", syncHandler);
    return () => window.removeEventListener("storage", syncHandler);
  }, [navigate]);


  // 🔹 RPM usuario
  const { rpm, started, startDetection, stopDetection } = useRPM();

  // 🔹 Inicializar fake
  useEffect(() => {
    const inicial = NOMBRES_FAKE.map((nombre) => ({
      nombre,
      rpm: Math.floor(Math.random() * 40) + 60,
      emojiActivo: null,
    }));
    setPersonas(inicial);
  }, []);

  // 🔹 Actualizar cada 8s
  useEffect(() => {
    const interval = setInterval(() => {
      setPersonas((prev) =>
        prev.map((p) => {
          const nuevaRpm = Math.floor(Math.random() * 40) + 60;
          const lanzarEmoji = Math.random() < 0.4;
          const emojiRandom = lanzarEmoji
            ? EMOJIS[Math.floor(Math.random() * EMOJIS.length)]
            : null;
          return { ...p, rpm: nuevaRpm, emojiActivo: emojiRandom };
        })
      );
      setTimeout(() => {
        setPersonas((prev) => prev.map((p) => ({ ...p, emojiActivo: null })));
      }, 5000);
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  // 🔹 Emojis propios con puntos
  const handleEmoji = (emoji) => {
    setMiEmoji(emoji);
    setTimeout(() => setMiEmoji(""), 5000);

    // ➕ sumar 1 al contador de emojis lanzados
    setPuntosRanking((prev) => prev + 1);

    // ➕ sumar 0.1 puntos a la sesión
    setPuntosLocal((prev) => {
      const nuevosLocal = parseFloat((prev + 0.1).toFixed(1));
      const totalSesion = parseFloat((puntosSesion + nuevosLocal).toFixed(1));

      console.log("👉 Local:", nuevosLocal, "Total sesión:", totalSesion);

      // 🔹 Avisar con modal en modo Free
      checkBonusFree(totalSesion);

      return nuevosLocal;
    });

  };

  // nuevo estado
  const ultimoUmbralRef = useRef(0);

  const checkBonusFree = (puntosTotalesSesion) => {
    const totalEntero = Math.floor(puntosTotalesSesion);
    const umbral = Math.floor(totalEntero / 1000) * 1000;

    if (umbral > 0 && umbral !== ultimoUmbralRef.current) {
      ultimoUmbralRef.current = umbral; // ✅ guardamos el nuevo umbral inmediatamente
      setModalMessage(
        `⚡ Has alcanzado ${umbral} puntos. En Premium esto se convierte en tokens 🎟️`
      );
      setModalOpen(true);
    }
  };

  // 🔹 Guardar entreno local (FREE)
  const handleGuardar = () => {
    const nuevoEntreno = {
      fecha: new Date().toLocaleDateString(),
      duracion: document.getElementById("reloj-duracion")?.innerText || "00:00",
      distancia: document.getElementById("distancia-recorrido")?.innerText || "0 Km",
      calorias: document.getElementById("calorias-gastadas")?.innerText || "0 Kcal",
      cadenciaMedia: rpm,
      emojis: puntosRanking,  // 👈 guarda emojis lanzados
      puntos: Math.floor(puntosSesion + puntosLocal),
      modo: "Free",
    };

    // 🔍 Cargar historial y comprobar duplicados
    const entrenos = JSON.parse(localStorage.getItem("historialEntrenos") || "[]") || [];

    const yaExiste = entrenos.some(
      (e) =>
        e.fecha === nuevoEntreno.fecha &&
        e.modo === "Free"
    );

    if (yaExiste) {
      setModalType("error");
      setModalMessage("⚠️ Este entreno ya fue guardado.");
      setModalOpen(true);
      return; // 👈 salimos sin guardar nada
    }

    // ✅ Guardar solo si no existe
    entrenos.push(nuevoEntreno);
    localStorage.setItem("historialEntrenos", JSON.stringify(entrenos));

    setModalType("success");
    setModalMessage("✅ Entreno guardado correctamente.");
    setModalOpen(true);

    navigate("/resumentreno");
  };


  // 🔹 Otros botones
  const handleRanking = () => navigate("/Ranking");

  const handleCerrarClase = async () => {
    try {
      if (user?.uid) {
        await EstadoLogout();       // 🔹 actualiza en Firestore

      }

      localStorage.removeItem("gimnasio");
      localStorage.setItem("cerrarClase", Date.now()); // 🔄 notificar a todas las pestañas
      navigate("/comprobacion");
    } catch (err) {
      console.error("❌ Error al cerrar clase:", err);
    }
  };





  const handleLogout = async () => {
    try {
      if (user?.uid) {
        await EstadoLogout();
      }

      setPuntosSesion(0);
      setPuntosLocal(0);
      stopDetection();
      localStorage.removeItem("gimnasio");

      // 🔄 Notificar a otras pestañas
      localStorage.setItem("logout", Date.now());

      // 🚪 Cerrar sesión Firebase (esto propaga en todas las pestañas con onAuthStateChanged)
      await logout();

      console.log("✅ Logout completo desde HomeUser");
    } catch (err) {
      console.error("❌ Error en logout:", err);
    }
  };



  // 🔹 Efecto para sumar puntos automáticamente cada 5 minutos en base a RPM
  useEffect(() => {
    if (!started) return;

    const interval = setInterval(() => {
      if (rpm > 0) {
        const puntosGanados = Math.floor(rpm / 10); // ej: 80rpm = 8 puntos

        setPuntosLocal((prev) => {
          const nuevosLocal = prev + puntosGanados;
          const totalSesion = puntosSesion + nuevosLocal;

          console.log(`⏱️ AutoPuntos: +${puntosGanados} (RPM=${rpm}) → Sesión=${totalSesion}`);
          // 🔹 Avisar con modal en modo Free

          checkBonusFree(totalSesion);
          return nuevosLocal;
        });
      }
    }, 1 * 60 * 1000); //guardamos cada 1 minutos

    return () => clearInterval(interval);
  }, [started, rpm, puntosSesion]);


  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex flex-col items-center text-white">
      {/* Header */}
      <div className="text-center mt-6 ">
        <img src={logo} alt="Logo" className="mx-auto w-40" />

        <p className="text-lg font-bold italic">
          🚴‍♂️ Lo que no hagas ahora, No lo harás nunca!
        </p>
      </div>

      {/* Monedero visible incluso en modo libre */}
      <div className="flex flex-col items-center mb-6 mt-4">
        <p className="text-xl font-bold text-yellow-400">
          🎟️ Tokens: {tokens}
        </p>
        <button
          onClick={() => navigate("/comprar-tokens")}
          
          className="mt-2 px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-lg shadow-md transition"
        >
          Comprar Tokens
        </button>

        {/* 🔹 Puntos acumulados (free UX) */}
        <p className="text-md font-semibold text-green-400 mt-3">
          🏆 Puntos sesión: {Math.floor(puntosSesion + puntosLocal)}
        </p>

        {/* 🔹 Barra de progreso hacia el bonus */}
        <div className="w-64 bg-gray-700 rounded-full h-4 mt-2 overflow-hidden">
          <div
            className="bg-green-500 h-4"
            style={{
              width: `${(((puntosSesion + puntosLocal) % 1000) / 1000) * 100}%`
            }}
          ></div>
        </div>

        <p className="text-sm text-gray-300 mt-1">
          {(Math.floor(puntosSesion + puntosLocal) % 1000)} / 1000 puntos para bonus
        </p>
      </div>


      {/* Métricas */}

      <div className="grid grid-cols-3 gap-4 w-full max-w-md mb-6">
        <div className="bg-white/10 backdrop-blur-md rounded-xl py-4 text-center shadow-md">
          <div id="reloj-duracion" className="text-xl font-bold">
            <Reloj />
          </div>
          <p className="text-gray-300 text-sm">Duración</p>
        </div>
        <div className="bg-white/10 backdrop-blur-md rounded-xl py-4 text-center shadow-md">
          <div id="distancia-recorrido" className="text-xl font-bold text-blue-400">
            <Distancia rpm={rpm} />
          </div>
          <p className="text-gray-300 text-sm">Distancia</p>
        </div>
        <div className="bg-white/10 backdrop-blur-md rounded-xl py-4 text-center shadow-md">
          <div id="calorias-gastadas" className="text-xl font-bold text-orange-400">
            <Calorias rpm={rpm} />
          </div>
          <p className="text-gray-300 text-sm">Calorías</p>
        </div>
      </div>



      {/* RPM central */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white/10 backdrop-blur-lg rounded-full w-56 h-56 flex flex-col items-center justify-center shadow-lg mb-6"
      >
        <p className="text-md mb-1">{nombreUsuario}</p>
        <p className="text-6xl font-extrabold text-green-400">{rpm}</p>
        <p className="text-md">RPM</p>
        {miEmoji && <p className="text-5xl mt-2 animate-bounce">{miEmoji}</p>}
      </motion.div>

      {/* Botón sensores */}
      {!started && (
        <button
          onClick={startDetection}
          className="mb-4 px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md text-sm"
        >
          Activar sensores
        </button>
      )}

      {/* Emojis */}
      <h2 className="text-md font-semibold mt-2 mb-2">Reacciona</h2>
      <div className="grid grid-cols-5 gap-2 w-full max-w-md px-2 mb-6">
        {EMOJIS.map((emoji, i) => (
          <button
            key={i}
            onClick={() => handleEmoji(emoji)}
            className="bg-white/10 hover:bg-white/20 rounded-lg py-3 text-2xl shadow-md transition"
          >
            {emoji}
          </button>
        ))}
      </div>

      {/* Teaser de propinas */}
      <div className="bg-white/10 text-gray-300 text-center p-4 rounded-xl mb-6 max-w-md">
        💡 En los canales premium podrás dar propinas a tus instructores favoritos.<br></br>
        <button
          onClick={handleCerrarClase}
          className="mt-3 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg shadow-md"
        >
          Explorar canales
        </button>
      </div>


      {/* Otros ciclistas */}
      <h2 className="text-md font-semibold mt-2 mb-3">Otros ciclistas</h2>
      <div className="grid grid-cols-3 sm:grid-cols-3 gap-3 w-full max-w-md px-4 mb-6">
        {personas.map((persona, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-gradient-to-br from-gray-700/80 to-gray-900/80 rounded-xl px-3 py-3 flex flex-col items-center shadow-lg"
          >
            <p className="text-xs font-medium truncate">{persona.nombre}</p>
            <p className="text-xl font-bold text-blue-400">{persona.rpm}</p>
            <p className="text-sm">RPM</p>
            {persona.emojiActivo && (
              <p className="text-2xl mt-1 animate-bounce">{persona.emojiActivo}</p>
            )}
          </motion.div>
        ))}
      </div>

      {/* Botones acción */}
      <div className="grid grid-cols-2 gap-3 w-full max-w-md px-4 mb-10">
        <button
          onClick={handleGuardar}
          className="bg-gradient-to-r from-green-400 to-emerald-600 hover:from-green-500 hover:to-emerald-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Guardar entreno
        </button>
        <button
          onClick={handleRanking}
          className="bg-gradient-to-r from-blue-400 to-indigo-600 hover:from-blue-500 hover:to-indigo-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Ranking
        </button>

        <button
          onClick={() => navigate("/historial")}
          className="bg-gradient-to-r from-purple-400 to-purple-600 hover:from-purple-500 hover:to-purple-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Ver historial
        </button>

        <button
          onClick={handleCerrarClase}
          className="bg-gradient-to-r from-yellow-400 to-orange-600 hover:from-yellow-500 hover:to-orange-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          🚪 Cerrar Clase
        </button>

        {/* 👇 Este ocupa toda la fila */}
        <button
          onClick={handleLogout}
          className="col-span-2 bg-gradient-to-r from-red-400 to-red-700 hover:from-red-500 hover:to-red-800 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Logout
        </button>
      </div>


      {/* Modal informativo Free */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-900 text-white p-6 rounded-2xl shadow-xl w-80 text-center">
            <h2 className="text-lg font-bold text-yellow-400 mb-4">
              {modalMessage}
            </h2>

            <button
              onClick={() => {
                navigate("/comprar-tokens"); // redirige a premium

              }}
              className="mt-3 px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg shadow-md"
            >
              🚀 Ir a Premium
            </button>

            {/* Botón Modo Libre */}
            <button
              onClick={() => setModalOpen(false)}  // 👈 usar el estado correcto
              className="mt-3 ml-3 px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg shadow-md"
            >
              ✨ Quedarme en modo libre
            </button>
          </div>
        </div>
      )}


      {/* Frase motivacional */}
      <p className="text-gray-300 italic mb-6">
        "You'll Never Train Alone 🚴‍♂️🔥"
      </p>

      {/* Donar */}
      <a
        href="https://www.paypal.me/trottingteam"
        target="_blank"
        rel="noopener noreferrer"
        className="mb-6"
      >
        <img
          src="https://trottingexperience.com/wp-content/uploads/2024/02/Boton-donar-paypal-300x166-.png"
          className="w-48 h-auto object-cover rounded-md mx-auto shadow"
          alt="Botón de donar a través de PayPal"
        />
      </a>
    </div>
  );
}

export default HomeUser;
